module.exports = __webpack_public_path__ + "img/Suriname.1adc76db.svg";